import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getContactTypes } from './ProfilePersonalInformation.selectors';
import { ProfilePersonalInformation } from './ProfilePersonalInformation.js';
import { actions } from './ProfilePersonalInformation.actions';

const ProfilePersonalInformationComponent = () => {
    const dispatch = useDispatch();

    const contactTypes = useSelector(getContactTypes);
    const nickname = useSelector((state) => state?.user?.publisher?.nickname || '');
    const advertiserId = useSelector((state) => state?.user?.advertiser?.id || '');
    const advertiserKey = useSelector((state) => state?.user?.advertiser?.advertiser_key || '');
    const anonymous = useSelector((state) => state?.user?.publisher?.anonymous ?? true);
    const subscribed = useSelector((state) => state?.user?.publisher?.subscribed ?? true);
    const contacts = useSelector((state) => state?.user?.publisher?.contacts || []);
    const name = useSelector((state) => state?.user?.publisher?.name || '');
    const surname = useSelector((state) => state?.user?.publisher?.surname || '');
    const rank = useSelector((state) => state?.user?.publisher?.rank || 0);
    const email = useSelector((state) => state?.user?.email || '');
    const ranks = useSelector((state) => state?.publisherRanks || []);

    const settingsSave = useCallback((stateData, onSuccess, onError) => {
        dispatch(actions.settingsSave(stateData, onSuccess, onError));
    }, [dispatch]);

    return (
        <ProfilePersonalInformation
            contactTypes={contactTypes}
            nickname={nickname}
            advertiserId={advertiserId}
            advertiserKey={advertiserKey}
            anonymous={anonymous}
            subscribed={subscribed}
            contacts={contacts}
            name={name}
            surname={surname}
            rank={rank}
            email={email}
            ranks={ranks}
            settingsSave={settingsSave}
        />
    );
};

export default ProfilePersonalInformationComponent;